const getCustomFontPairsToDelete = (initialCustomFontPairs, currentCustomFontPairs) => {
  const initialCustomFontPairsIds = initialCustomFontPairs.map((p) => p.id);
  const currentCustomFontPairsIdsSet = new Set(currentCustomFontPairs.map((p) => p.id));

  return initialCustomFontPairsIds.filter((id) => !currentCustomFontPairsIdsSet.has(id));
};

export default getCustomFontPairsToDelete;
